import { render, staticRenderFns } from "./ListCreateDialog.vue?vue&type=template&id=71935b51&"
import script from "./ListCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./ListCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports